module.exports = __webpack_public_path__ + "static/additional-menu-56cb885cef9aa823931357c5c84d8e81.png";